// extracted by mini-css-extract-plugin
module.exports = {"header":"header-3ZVOM","friendTotalLink":"friendTotalLink-3zt1-","linkContainer":"linkContainer-Lnz-2","link":"link-2pFfg"};